var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_vm._v(" avec "),_c('a',{attrs:{"href":"https://maprochaineauto.com","title":"maprochaineauto","target":"_blank"}},[_c('img',{attrs:{"src":_vm.logoMaprochaineauto,"alt":"logo","height":"16"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }